import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import Chapters from "../components/DrawerAccordion/Chapters";
import Wrapper from "../components/Wrapper/Wrapper";
import db from "../popisy.json";
import styles from "./Rzzj.module.css";

const data = Object.values(db);

const Descriptions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Wrapper>
      <Helmet>
        <title>Popisy referenčních úrovní A1-B2 pro ČZJ</title>
      </Helmet>
      <Breadcrumbs />
      <div className={styles.accordionWrapper}>
        <h2 className={styles.headingTop}>
          Popisy referenčních úrovní A1-B2 pro ČZJ
        </h2>
        <Chapters baselink="popisy" data={data} />
      </div>
    </Wrapper>
  );
};

export default Descriptions;
